import { navLinks } from '@/mocks/chiguaData';

export default function Footer() {
  const handleAnchor = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-secondary-100/60 border-t border-secondary-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 pt-12 md:pt-16 pb-8">
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 md:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-2">
              <span className="w-10 h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-leaf-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
                吃瓜<span className="text-primary-600">网站</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              聚合全网热门吃瓜内容与动态的入口导航页。官网入口、最新地址与备用入口随时在线，帮你在任何情况下快速找到通往吃瓜网站首页的路。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 md:gap-16">
            <div>
              <h4 className="text-sm font-semibold text-foreground-900">快捷导航</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {navLinks.map((l) => (
                  <li key={l.id}>
                    <button
                      onClick={() => handleAnchor(l.id)}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900">联系方式</h4>
              <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-600">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-foreground-500"></i>contact@chigua.example
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-foreground-500"></i>24 小时在线同步
                </li>
              </ul>
              <div className="mt-4 flex items-center gap-2">
                {['ri-weibo-line', 'ri-qq-line', 'ri-wechat-line'].map((ic) => (
                  <span
                    key={ic}
                    className="w-9 h-9 rounded-full bg-background-50 flex items-center justify-center text-foreground-500 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer"
                  >
                    <i className={`${ic} text-lg`}></i>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            本站为导航聚合页，非官方网站。官网入口、最新地址、备用入口以官方信息为准。
          </p>
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} 吃瓜网站 · 入口导航</p>
        </div>
      </div>
    </footer>
  );
}